import {useShopActions} from '../../internal/useShopActions'
import {ShopActions} from '../../types'

interface UseErrorScreenReturns {
  /**
   * Show an error screen with the given error message.
   */
  showErrorScreen: ShopActions['showErrorScreen']
}

export const useErrorScreen = (): UseErrorScreenReturns => {
  const {showErrorScreen} = useShopActions()

  return {showErrorScreen}
}
